import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

import Sidebar from "~/components/Sidebar";
import {
	invoiceRecipientQuery,
	processedInvoiceQueries,
} from "~/modules/billing/api/processedInvoice/processedInvoiceQueries.ts";
import type { Invoice } from "~/modules/billing/api/processedInvoice/processedInvoiceTypes.ts";
import UpdateInvoiceRecipientForm
	from "~/modules/billing/components/InvoiceDetailsView/components/UpdateInvoiceRecipientSidebar/components/UpdateInvoiceRecipientForm.tsx";

type Props = {
	isOpen: boolean;
	onClose: () => void;
	invoiceData: Invoice
};

const UpdateInvoiceRecipientSidebar = ({
	invoiceData,
	isOpen,
	onClose,
}: Props) => {
	const queryClient = useQueryClient();
	const handleSuccess = useCallback(async () => {
		await queryClient.refetchQueries({ queryKey: processedInvoiceQueries.details(invoiceData.id).queryKey });
		if (invoiceData.projectId) {
			queryClient.invalidateQueries({ queryKey: processedInvoiceQueries.byProject(invoiceData.projectId).queryKey });
		}
		onClose();
	}, [invoiceData.id, invoiceData.projectId, onClose, queryClient]);

	const handleClose = useCallback(() => {
		queryClient.removeQueries(invoiceRecipientQuery(invoiceData.id));
		onClose();
	}, [invoiceData.id, onClose, queryClient]);

	return (
		<Sidebar closeOnOutsideClick={false}
				 open={isOpen}
				 setOpen={handleClose}>
			{isOpen && <UpdateInvoiceRecipientForm key={isOpen ? "open" : "closed"}
												   invoiceData={invoiceData}
												   onCancel={handleClose}
												   onSuccess={handleSuccess}
			/>}
		</Sidebar>
	);
};

export default UpdateInvoiceRecipientSidebar;
